const SEX = {
    MALE: {
        value: "MALE",
        label: "männlich"
    },
    FEMALE: {
        value: "FEMALE",
        label: "weiblich"
    }
}, ROLES = {
    ADMIN: "ADMIN",
    COACH: "COACH",
    MEMBER: "MEMBER"
}

export {SEX, ROLES};